<template>
  <el-card>
    <el-form class="global-form2" ref="form" :model="formData" :rules="rules" label-width="90px" label-position="right">
      <template v-if="elementId">
        <el-form-item label="巡查对象" prop="elementName">
          <el-input v-model="formData.elementName" disabled></el-input>
        </el-form-item>
      </template>
      <template v-else>
        <el-form-item label="巡查对象" prop="elementName" :rules="[
          { required: true, message: '请输入巡查对象名称', trigger: ['blur', 'change'] }
        ]">
          <el-input v-model="formData.elementName" placeholder="请输入巡查对象名称" maxlength="20" show-word-limit
            clearable></el-input>
        </el-form-item>
      </template>
      <el-form-item label="风险分级" prop="riskLevel">
        <el-select v-model="formData.riskLevel" placeholder="请选择风险分级" filterable clearable>
          <el-option v-for="(item, index) in riskLevelList" :label="item.dicValue" :value="item.dicCode"
            :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="检查标准" prop="standardList">
        <el-table class="global-table" :data="formData.standardList || []">
          <el-table-column label="内容" show-overflow-tooltip prop="standardContent" min-width="180px">
            <template v-slot="{ row }">
              <template v-if="row.isEdit">
                <el-form class="global-add-form" ref="standardForm" :model="standardForm" :rules="standardRules">
                  <el-form-item prop="standardContent">
                    <el-input v-model="standardForm.standardContent" placeholder="请输入检查标准" maxlength="50"
                      show-word-limit clearable></el-input>
                  </el-form-item>
                </el-form>
              </template>
              <template v-else>
                {{ row.standardContent }}
              </template>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="100px" fixed="right">
            <template v-slot="{ row, $index }">
              <template v-if="row.isEdit">
                <el-button class="mb20" type="text" @click="onSave(row, $index)">保存</el-button>
                <el-button class="mb20" type="text" @click="onCancel(row, $index)">取消</el-button>
              </template>
              <template v-else>
                <el-button class="mb20" type="text" @click="onEdit(row)">编辑</el-button>
                <el-button class="mb20" type="text" @click="onDelete($index)">删除</el-button>
              </template>
            </template>
          </el-table-column>
        </el-table>
        <el-button type="text" @click="onAdd">新增检查标准</el-button>
      </el-form-item>
      <el-form-item label="巡查频次" prop="corpFrequency">
        <div class="frequencyList">
          <span class="name">管理抽查</span>
          <el-input-number v-model="formData.corpFrequency" controls-position="right" :min="1" :max="31"
            placeholder="请输入巡查频次"></el-input-number>
          <span class="unit">次/</span>
          <el-select v-model="formData.corpFrequencyType">
            <el-option v-for="(item, index) in cycleList" :label="item" :value="index + 1" :key="index"></el-option>
          </el-select>
        </div>
        <div class="frequencyList">
          <span class="name">项目自查</span>
          <el-input-number v-model="formData.cooperateFrequency" controls-position="right" :min="1" :max="31"
            placeholder="请输入巡查频次"></el-input-number>
          <span class="unit">次/</span>
          <el-select v-model="formData.cooperateFrequencyType">
            <el-option v-for="(item, index) in cycleList" :label="item" :value="index + 1" :key="index"></el-option>
          </el-select>
        </div>
      </el-form-item>
      <el-form-item label="管控措施" prop="controlMeasures">
        <el-input v-model="formData.controlMeasures" type="textarea" :autosize="{ minRows: 4, maxRows: 8 }"
          placeholder="请输入管控措施" maxlength="1000" show-word-limit clearable></el-input>
      </el-form-item>
      <el-form-item label="应急处置" prop="emergencyDisposal">
        <el-input v-model="formData.emergencyDisposal" type="textarea" :autosize="{ minRows: 4, maxRows: 8 }"
          placeholder="请输入应急处置" maxlength="1000" show-word-limit clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submit" :disabled="disabled">确定</el-button>
        <el-button @click="$router.back()">取消</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
export default {
  name: 'ElementAddPage',
  data () {
    return {
      cycleList: ['日', '周', '月'],
      riskLevelList: [],
      disabled: false,
      formData: {
        riskLevel: '',
        standardList: [],
        corpFrequency: 1,
        corpFrequencyType: 1,
        cooperateFrequency: 1,
        cooperateFrequencyType: 1,
        controlMeasures: '',
        emergencyDisposal: '',
        elementName: ''
      },
      rules: {
        standardList: [
          { required: true, message: '请添加检查标准', trigger: ['change'] }
        ]
      },
      standardForm: {
        standardContent: ''
      },
      standardRules: {
        standardContent: [
          { required: true, message: '请输入检查标准', trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  computed: {
    elementId () {
      return this.$route.params.elementId
    }
  },
  created () {
    this.elementId && this.loadData()
    this.loadRiskLevelList()
  },
  methods: {
    loadRiskLevelList () {
      this.$axios.get(this.$apis.common.selectDicByList, {
        dicType: 'riskLevel'
      }).then(res => {
        this.riskLevelList = res.riskLevel || []
      })
    },

    loadData () {
      this.$axios.get(this.$apis.patrol.selectElementByElementId, {
        elementId: this.elementId
      }).then(res => {
        res.standardList.map((item) => {
          item.isEdit = false
          return item
        })
        this.formData = res || {}
      })
    },

    onAdd () {
      if (this.formData.standardList.some(item => item.isEdit)) {
        this.$message.warning('请先保存正在编辑的标准')
      } else if (this.formData.standardList.length < 50) {
        this.formData.standardList.push({
          standardContent: '',
          isEdit: true
        })
      } else {
        this.$message.warning('检查标准最多只能添加50条')
      }
    },

    onEdit (row) {
      const editIndex = this.formData.standardList.findIndex(item => item.isEdit)
      if (editIndex !== -1) {
        this.onCancel(this.formData.standardList[editIndex], editIndex)
      }
      this.standardForm = JSON.parse(JSON.stringify(row))
      row.isEdit = true
    },

    onCancel (row, index) {
      if (row.standardId) {
        row.isEdit = false
      } else {
        this.formData.standardList.splice(index, 1)
      }
      this.standardForm = {
        standardContent: ''
      }
    },

    onSave (row, index) {
      this.$refs.standardForm.validate().then(() => {
        const index2 = this.formData.standardList.findIndex(item => item.standardContent === this.standardForm.standardContent)
        if (index2 !== -1 && index2 !== index) {
          this.$message.warning('该标准已经添加，请不要重复添加')
        } else {
          row.isEdit = false
          this.formData.standardList[index].standardContent = this.standardForm.standardContent
          this.standardForm.standardContent = ''
        }
      })
    },

    onDelete (index) {
      this.formData.standardList.splice(index, 1)
    },

    submit () {
      this.$refs.form.validate().then(() => {
        if (this.formData.standardList.some(item => item.isEdit)) {
          this.$message.warning('请先保存正在编辑的标准')
        } else {
          this.disabled = true
          const formData = JSON.parse(JSON.stringify(this.formData))
          formData.standardList.forEach((item) => {
            delete item.isEdit
          })
          console.log('formData', formData)
          const url = this.elementId ? this.$apis.patrol.updateElement : this.$apis.patrol.insertElement
          this.$axios.post(url, {
            ...formData
          }).then(() => {
            this.$message.success(this.elementId ? '编辑成功' : '新增成功')
            this.$router.push({ name: 'patrolElementList', params: { type: this.$route.params.type } })
          }).finally(() => {
            this.disabled = false
          })
        }
      })
    }
  }

}
</script>

<style scoped lang="scss">
.global-table {
  margin-top: -13px;
}

.frequencyList {
  display: flex;

  .name {
    padding-right: 10px;
  }

  .unit {
    padding: 0 10px;
  }

  &:not(:last-child) {
    margin-bottom: 20px;
  }

  ::v-deep {
    .el-input-number {

      &,
      .el-input {
        width: 200px;
      }
    }

    .el-select {

      &,
      .el-input {
        width: 80px;
      }
    }
  }
}
</style>
